export const updateToken = (state, {token}) => {
    sessionStorage.setItem('token', token)
    state.token = token
}
